export default __webpack_public_path__ + "assets/webgl/controllers_btns.918191d1.bin";